/**
 * Login route component.
 * @module Login
 *
 *
 */
import React from "react"

import LoginContainer from "features/Login/containers/Login.container"

/**
 * Renders the Login route component.
 * @returns  The rendered Login component.
 */
const Login: React.FC = () => {
  return (
    <>
      <title>DATA(Q) - Login</title>
      <LoginContainer />
    </>
  )
}

export default Login
